import { render, staticRenderFns } from "./SuccessSubmited.vue?vue&type=template&id=013b3f06&scoped=true&"
import script from "./SuccessSubmited.vue?vue&type=script&lang=js&"
export * from "./SuccessSubmited.vue?vue&type=script&lang=js&"
import style0 from "./SuccessSubmited.vue?vue&type=style&index=0&id=013b3f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b3f06",
  null
  
)

export default component.exports